import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

interface useAvatarOptions {
	userId?: string | null;

	enabled?: boolean;
}

const fetchUserAvatar = async (id?: string | null) => {
	if (!id) return Promise.reject("No ID supplied");

	const { data } = await cmsClient.get(`/socialprofile/avatar/${id}/`, {
		responseType: "blob"
	});

	return URL.createObjectURL(data);
};

export const useAvatar = ({ userId, enabled = true }: useAvatarOptions) => {
	const query = useQuery(["avatar", userId], () => fetchUserAvatar(userId), {
		staleTime: 86400000, // 24 hours cache
		enabled: enabled && Boolean(userId)
	});

	return query;
};
